import { useNextTranslation } from "./useNextTranslation";

export const useProductTranslation = () => useNextTranslation("product");
